import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { presentFormatedData, presentDate } from '../../../functionalComponents/dataFormatFunctions';

const useStyles = makeStyles((theme) => ({
  font: {
    fontWeight: 600,
    textAlign: 'initial',
    paddingBottom: '0.25rem',
    fontSize: '1rem',
  },
  fontPadding: {
    textAlign: 'initial',
    overflow: 'auto',
    paddingTop: '0.25rem',
    fontSize: '1rem',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },
  rowContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

const PostShipmentInformation = (props) => {
  const classes = useStyles();
  const { batchDetails, selectedBatch } = props;
  

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={8} sm={12} md={12} className={classes.grid}>
          <Typography variant='h4' className={classes.title}>
            Post-Shipment Information
          </Typography>
          <span className={classes.borders}></span>
        </Grid>

        <Grid container item xs={12} className={classes.rowContainer}>
          {batchDetails.dispatchDate && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Shipment Date
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentDate(batchDetails.dispatchDate)}
              </Typography>
            </Grid>
          )}
          {batchDetails?.dispatchQuantity !== null && batchDetails?.dispatchQuantity !== undefined && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Quantity Shipped
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails?.dispatchQuantity)}
              </Typography>
            </Grid>
          )}
          {batchDetails?.uomQA !== null && batchDetails?.uomQA !== undefined && batchDetails?.uomQA !== '' && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                UOM
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails?.uomQA)}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Grid container item xs={12} className={classes.rowContainer}>
          {batchDetails.sealNumber && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Seal Number
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.sealNumber)}
              </Typography>
            </Grid>
          )}
          {batchDetails.shipperName && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Shipper Name
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(batchDetails.shipperName)}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <hr />
    </React.Fragment>
  );
};

export default PostShipmentInformation;